import { Affix, Button, Card, Space, Spin } from "antd";
import { NEW_TNA_SUMMARY_GRAPH } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { isMobileView } from "components/Common/AppHelper";
import LineChart from "components/Common/Charts/LineChart";
import Header from "components/Common/Header";
import HandleNotification from "common/Notification";
import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const NewSummaryProgress = ({ width }) => {
  const { salesContractId } = useParams();
  const [progressData, setProgressData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchProgressData = useCallback(async () => {
    if (!salesContractId) return;
    setIsLoading(true);
    const response = await getData(
      `${NEW_TNA_SUMMARY_GRAPH}/${salesContractId}`,
      false,
    );
    if (response?.data?.code === 200) {
      const allDatas = response?.data?.data;
      const result = (Array.isArray(allDatas) ? allDatas : []).flatMap(
        (data) => {
          const { title, actual_date, due_date } = data;

          if (!actual_date && !due_date) {
            return [];
          }
          if (!actual_date && due_date) {
            return [
              { title, date: due_date, type: "Due Date", value: due_date },
            ];
          }
          if (actual_date && !due_date) {
            return [
              {
                title,
                date: actual_date,
                type: "Actual Date",
                value: actual_date,
              },
            ];
          }
          return [
            {
              title,
              date: actual_date,
              type: "Actual Date",
              value: actual_date,
            },
            { title, date: due_date, type: "Due Date", value: due_date },
          ];
        },
      );
      setProgressData(result);
    } else if (response?.status === 403 || response?.data?.code === 403) {
      HandleNotification("error", "bottomRight", "Access denied!", null);
      setProgressData([]);
    }
    await new Promise((r) => setTimeout(r, 300));
    setIsLoading(false);
  }, [salesContractId]);

  useEffect(() => {
    fetchProgressData();
  }, [fetchProgressData]);

  const extra = (
    <Space>
      <Button type="primary" size="small" style={{ float: "right" }}>
        <Link to="/tanda/new-summary">Back to List</Link>
      </Button>
    </Space>
  );

  return (
    <Spin spinning={isLoading}>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="T&A Summary Progress"
            subTitle=""
            actions={extra}
          />
        </Card>
      </Affix>
      <div className="mt-4">
        {progressData?.length > 0 ? (
          <LineChart title="T&A Progress" progressData={progressData} />
        ) : (
          <div>No Data Found</div>
        )}
      </div>
    </Spin>
  );
};

export default NewSummaryProgress;
